import script from "./RuntimePopupModal.vue?vue&type=script&setup=true&lang=js"
export * from "./RuntimePopupModal.vue?vue&type=script&setup=true&lang=js"

import "./RuntimePopupModal.vue?vue&type=style&index=0&id=5a579ca9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a579ca9"]])

export default __exports__